import * as React from 'react'
import { forwardRef } from 'react'
import PhoneInput from 'react-phone-number-input/react-hook-form-input'
import { Control, useFormState } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Box, InputAdornment, TextField } from '@mui/material'
import { parsePhoneNumber } from 'react-phone-number-input'
import LanguageIcon from '@mui/icons-material/Language'
import { TextFieldProps } from '@mui/material/TextField/TextField'

type CustomPhoneInputProps = {
    value: string
}

const CustomPhoneInput = forwardRef<HTMLInputElement, CustomPhoneInputProps & TextFieldProps>((props, ref) => {
    const phoneNumber = parsePhoneNumber(props.value)
    return (
        <TextField
            {...props}
            fullWidth
            inputRef={ref}
            InputProps={{
                startAdornment: <InputAdornment position="start">
                    {phoneNumber?.country ?
                        <Box sx={{
                            width: 24,
                            height: 24,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <img src={`https://flagcdn.com/w40/${phoneNumber.country.toLowerCase()}.png`}
                                 style={{ maxWidth: '24px' }}/>
                        </Box>
                        :
                        <LanguageIcon/>
                    }
                </InputAdornment>
            }}
        />
    )
})

type PhoneNumberInputProps = {
    control: Control<any>
    fieldName: string
    componentName: string
}

export const PhoneNumberInput = ({ fieldName, componentName, control }: PhoneNumberInputProps) => {
    const { t } = useTranslation()
    const { errors } = useFormState({ control })
    return <PhoneInput
        international
        name={fieldName}
        control={control}
        label={t(`${componentName}.${fieldName}.label`)}
        error={!!errors?.hasOwnProperty(fieldName)}
        helperText={!!errors?.hasOwnProperty(fieldName)
            ? t(`${componentName}.${fieldName}.error`)
            : t(`${componentName}.${fieldName}.helperText`)}
        inputComponent={CustomPhoneInput}
    />
}
